import Request from "../../../utils/Request"
import { AxiosResponse } from "axios"

/**
 * @param data
 * @param queryString
 * @returns {Promise<AxiosResponse<T>>}
 * @constructor
 */
const GetIfaEmployers = (data:any[] = false, queryString = {}): Promise<AxiosResponse<T>> => {
	if (queryString) {
		return Request.post( `/advisors/employers_ifa/employers-paginate?${Request.parseParams(queryString)}`, data);
	}
	return Request.post("/advisors/individuals_ifa/employers-paginate", data);
}

/**
 * @returns {Promise<AxiosResponse<any>>}
 */
export default GetIfaEmployers
